import axios from "axios";

// Base URL for your API
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getDoctorById = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/doctors/${id}`);
        return response.data; // The doctor object
    } catch (error) {
        console.error("Error fetching doctor:", error);
        throw error;
    }
};

export const getAllDoctors = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/all-doctors`);
        return response.data; // { success, count, doctors }
    } catch (error) {
        console.error("Error fetching all doctors:", error);
        throw error;
    }
};

export const updateDoctor = async (id, doctorData) => {
    try {
        // Convert languages array to string if it's an array
        const payload = {
            ...doctorData,
            languages: Array.isArray(doctorData.languages) 
                ? doctorData.languages.join(', ') 
                : doctorData.languages
        };

        const response = await axios.put(`${API_BASE_URL}/doctors/${id}`, payload, {
            headers: { "Content-Type": "application/json" },
        });

        return response.data;
    } catch (error) {
        console.error("Error updating doctor:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};


